export default {
    page_title: 'Emprunts',
    page_description: 'Gérer les emprunts de ressources',
    myBorrowings: 'Mes Emprunts et Réservations',
    allBorrowings: 'Tous les Emprunts et Réservations',
    details: 'Détails',
    add_borrowing: 'Ajouter un Emprunt',
    edit_borrowing: 'Modifier l\'Emprunt',
    editTitle: 'Modifier l\'Emprunt',
    resource: 'Ressource',
    user: 'Utilisateur',
    borrower: 'Emprunteur',
    borrowed_date: 'Date d\'Emprunt',
    due_date: 'Date d\'Échéance',
    expected_return: 'Retour Attendu',
    expected_return_date: 'Date de Retour Prévue',
    expected_return_date_placeholder: 'Sélectionner la date et l\'heure de retour',
    return_date: 'Date de Retour',
    returned_at: 'Retourné le',
    returned_at_placeholder: 'Sélectionner la date et l\'heure de retour',
    return_notes: 'Notes de Retour',
    return_notes_placeholder: 'Entrez des notes sur le retour...',
    reservation_notes: 'Notes de Réservation',
    return_preview: 'Retour prévu :',
    is_returned: 'Retourné',
    status: 'Statut',
    notes: 'Notes',
    notes_placeholder: 'Entrez des notes sur cet emprunt...',
    add: 'Ajouter',
    edit: 'Modifier',
    borrow: 'Emprunter',
    return: 'Marquer comme Retourné',
    return_item: 'Retourner l\'Article',
    added_successfully: 'Emprunt ajouté avec succès',
    updated_successfully: 'Emprunt mis à jour avec succès',
    returned_successfully: 'Article retourné avec succès',
    invalid_date_range: 'La date d\'échéance doit être après la date d\'emprunt',
    active: 'Actif',
    returned: 'Retourné',
    overdue: 'En Retard',
    forMyself: 'Pour moi-même',
    borrowFor: 'Emprunter pour cet utilisateur',
    unknown_resource: 'Ressource Inconnue',
    unknown_user: 'Utilisateur Inconnu',
    expected_return_date_required: 'La date de retour prévue est requise',
    quickDate: {
        title: 'Sélection de la durée',
        hours: 'Heures',
        days: 'Jours',
        '1h': '1h',
        '2h': '2h',
        '3h': '3h',
        '4h': '4h',
        '6h': '6h',
        '8h': '8h',
        '12h': '12h',
        '1d': '1j',
        '2d': '2j',
        '3d': '3j',
        '4d': '4j',
        '5d': '5j',
        '6d': '6j',
        '7d': '7j',
        tooltip: 'Sélection rapide : {{label}}'
    },
    no_date_selected: 'Aucune date de retour sélectionnée',
    manual_date_selection: 'Sélection manuelle de la date',
    click_to_open_calendar: '(cliquez pour ouvrir le calendrier)',

    // Borrowing Return specific translations
    borrowingReturn: {
        returnBorrowing: 'Retourner l\'Emprunt',
        subtitle: 'Retour de {{resourceName}}',
        loading: 'Chargement...',
        notFound: 'Emprunt non trouvé',
        fetchError: 'Erreur lors de la récupération de l\'emprunt',
        returnError: 'Erreur lors du retour de l\'emprunt'
    },

    // Borrowing Borrow specific translations
    borrowingBorrow: {
        borrowResource: 'Emprunter une Ressource',
        subtitle: 'Emprunt de {{resourceName}}',
        loading: 'Chargement...',
        notFound: 'Réservation non trouvée',
        fetchError: 'Erreur lors de la récupération de la réservation',
        borrowError: 'Erreur lors de l\'emprunt de la ressource'
    },
    calendar: {
        tabLabel: 'Calendrier',
        title: 'Calendrier des Emprunts',
        description: 'Visualisez et ouvrez les emprunts dans le calendrier.'
    },

    // Participation
    participation: {
        title: 'Participation',
        myStatus: 'Ma Participation',
        yes: 'Participe',
        no: 'Ne participe pas',
        maybe: 'Peut-être',
        participants: 'Participants',
        participantsCount: '{{count}} participant(s)',
        noParticipants: 'Aucun participant pour le moment',
        statusUpdated: 'Statut de participation mis à jour',
        statusUpdateFailed: 'Impossible de mettre à jour le statut de participation',
        participantsYes: 'Confirmés',
        participantsMaybe: 'Incertains',
        participantsNo: 'Ne participent pas'
    },

    // Reservation Validation
    validation: {
        title: 'Validation de Réservation',
        currentStatus: 'Statut de Validation',
        validatedBy: 'Validé par',
        validatedAt: 'Validé le',
        notes: 'Notes de Validation',
        notesLabel: 'Notes (optionnel)',
        notesPlaceholder: 'Ajouter une note pour le demandeur...',
        approve: 'Approuver la Réservation',
        reject: 'Refuser la Réservation',
        validated: 'Réservation validée avec succès',
        rejected: 'Réservation refusée',
        error: 'Impossible de valider la réservation',
        pendingValidation: 'Cette réservation est en attente de validation par un gestionnaire.',
        validationRejected: 'Cette réservation a été refusée.',
        cannotBorrow: 'Cette ressource nécessite une validation de réservation. Veuillez d\'abord faire une réservation.',
        tabLabel: 'Validations',
        noPending: 'Aucune validation en attente',
        noPendingDescription: 'Toutes les réservations ont été traitées.'
    }
};
